import { Icon } from '../Icon';
import styles from './StarToggle.module.css';

/**
 * Star / Favorite toggle (piece 3): a native button carrying aria-pressed, so
 * its states announce and the browser's own focus ring comes with it. Off is
 * an outline star in the inactive grey; On is filled gold. The icon sits at
 * the inline icon size inside a 44px touch target with no chrome behind it.
 */
export interface StarToggleProps {
  pressed: boolean;
  onChange: (pressed: boolean) => void;
  /** The accessible name, naming what is favourited. */
  label: string;
}

export const starToggleDocumentedStates = ['off', 'on'] as const;

export function StarToggle({ pressed, onChange, label }: StarToggleProps) {
  return (
    <button
      type="button"
      className={`${styles.star} ${pressed ? styles.on : ''}`}
      aria-pressed={pressed}
      aria-label={label}
      data-star={pressed ? 'on' : 'off'}
      onClick={() => onChange(!pressed)}
    >
      <Icon meaning="star" size="inline" />
    </button>
  );
}
